export const config = {
  apiUrl: "https://wu8ksmdnv8.execute-api.eu-west-2.amazonaws.com/prod",
};
